import { Controller } from "@hotwired/stimulus";

/**
 * A simple controller that enables smooth scrolling to elements on the page.
 *
 * @example Basic usage - scroll to element with id "menus"
 *   <a href="#menus"
 *      data-controller="scroll-to"
 *      data-action="click->scroll-to#scrollTo touchstart->scroll-to#touchStart touchend->scroll-to#touchEnd">
 *     Scroll to menus
 *   </a>
 */
export default class extends Controller {
  touchY = 0;

  touchStart(event) {
    this.touchY = event.touches[0].clientY;
  }

  touchEnd(event) {
    const touchEndY = event.changedTouches[0].clientY;
    const moved = Math.abs(touchEndY - this.touchY) > 5;

    if (!moved) {
      this.scrollTo(event);
    }
  }

  /**
   * Smoothly scrolls to the element specified in the link's href.
   * The href should be a hash/anchor (e.g., "#menus", "#venues").
   *
   * @param {Event} event - The click event
   */
  scrollTo(event) {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href").slice(1);
    document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" });
  }
}
